<template>
  <print-receipt-frame
    ref="printkgireceipt"
    :is-preview="true"
  />
</template>

<script>
import PrintReceiptFrame from '@/views/ManagementFeeKGI/components/PrintReceiptFrame'
export default {
  components: {
    'print-receipt-frame': PrintReceiptFrame
  },
  mounted () {
    this.$refs.printkgireceipt.getReceiptData()
  }
}
</script>

<style>

</style>
